import { createContext } from "react"

export interface WeispaceAuthContextI {
  handleAuthLogout: () => void
}

const WeispaceAuthContext = createContext({} as WeispaceAuthContextI)

export default WeispaceAuthContext